import { ReactNode } from 'react'

import { cn } from '@/app/utils'

type Props = {
  children?: ReactNode
  className?: string
}

const BillsPayFooterWrapper = ({ children, className }: Props) => (
  <div
    className={cn(
      'flex items-end justify-between p-40 lg:p-24 sm:flex-col sm:gap-y-12 sm:px-0 sm:pb-32 sm:pt-16',
      className
    )}
  >
    {children}
  </div>
)

export { BillsPayFooterWrapper }
